// extracted by mini-css-extract-plugin
module.exports = {"Subhead":"Subhead_Subhead__w2HzS","Subhead--sizeY-compact":"Subhead_Subhead--sizeY-compact__T4nXE","Subhead--sizeY-none":"Subhead_Subhead--sizeY-none__QvoUs"};